// import * as API  from '@libs/MPAAPI/index';

class ComponentManifest extends Manifest {
	static async instantiate(
		localRootComponent : Component<any, any>,
		treeNodes : Component.ITreeNode[],
		topChilds : Component<any, any>[]
	) : Promise<Component<any, any>> {
		for (const childTreeNode of treeNodes) {
			const descriptor = {
				type :          childTreeNode.type,
				id :            childTreeNode.id,
				configuration : childTreeNode.configuration || {},
				isSlot :        childTreeNode.isSlot,
				slot :          childTreeNode.slot,
				declaredSlot :  childTreeNode.declaredSlot,
				tree :          localRootComponent
			};
			const childComponent = await localRootComponent.component_instantiateInnerChild(descriptor);
			topChilds.push(childComponent);
			const stack : [ Component<any, any>, Component.ITreeNode, string ][] = childTreeNode.childs.map(x => [
				childComponent,
				x,
				childTreeNode.id
			]);
			while (stack.length) {
				const [ parent, node, path ] = <typeof stack[0]> stack.shift();
				const component = await parent.component_instantiateOuterChild({
					type :          node.type,
					id :            node.id,
					configuration : node.configuration || {},
					isSlot :        node.isSlot,
					declaredSlot :  node.declaredSlot,
					slot :          node.slot || 'default',
					tree :          localRootComponent
				});
				for (const child of node.childs) {
					stack.push([ component, child, path + '.' + child.id ]);
				}
			}
		}
		return localRootComponent;
	};

	declare readonly inheritedManifest : ComponentManifest | null;
	declare readonly type : 'component';

	async instantiate(parent : Component<any, any>) : Promise<Component<any, any>> {
		await ComponentManifest.instantiate(parent, this.treeNodes, []);
		return parent;
	};

	protected constructor(
		source : string,
		initialXML : Element,
		type : string,
		inheritedManifest : ComponentManifest | null
	)
	{
		super(source, initialXML, type, inheritedManifest);
		this.configurations.template = {};
	};
};
namespace ComponentManifest {

}
export default ComponentManifest;
//@ts-ignore
ComponentManifest.prototype.type = 'component';
import Component from '../Component';
import Manifest  from '../Manifest';

Manifest.ComponentManifest = ComponentManifest;
